module.exports = __webpack_public_path__ + "static/media/fj.6503b5ca.svg";